// src/utils/emailjs.js
import emailjs from "@emailjs/browser";

export async function sendTaskAssignedEmail(toEmail, { taskText, dueDate }) {
  return emailjs.send(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    {
      to_email: toEmail,
      task_text: taskText,
      due_date: dueDate,
    },
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY
  );
}
